import app from 'flarum/common/app';
import getFlagEmojiUrl from '../util/getFlagEmojiUrl';
import Tooltip from 'flarum/common/components/Tooltip';
export const getDescription = ipInfo => {
  return ipInfo.organization() || ipInfo.isp() || ipInfo.error() || '';
};
export const getThreat = ipInfo => {
  return ipInfo.threatTypes() && ipInfo.threatTypes().join(', ');
};

/**
 * Render a flag image for a bare ISO 3166-1 alpha-2 country code. Shared by the
 * IP-derived flag (getFlagImage) and the user-selected custom flag.
 */
export const getFlagImageForCountry = countryCode => {
  if (!countryCode) {
    return null;
  }
  const url = getFlagEmojiUrl(countryCode);
  if (!url) {
    return null;
  }
  const currentLocale = app.translator.getLocale();

  // Create an instance of Intl.DisplayNames for displaying full country names
  const displayNames = new Intl.DisplayNames([currentLocale], {
    type: 'region'
  });

  // Get the full country name using the country code
  let countryName = countryCode;
  try {
    countryName = displayNames.of(countryCode) || countryCode;
  } catch (e) {
    // Intl.DisplayNames throws on codes it doesn't recognise; fall back to the code.
  }
  return m(Tooltip, {
    text: countryName
  }, m("img", {
    src: url,
    alt: countryName,
    height: "16",
    loading: "lazy"
  }));
};
export const getFlagImage = ipInfo => {
  var _ipInfo$countryCode;
  return getFlagImageForCountry(ipInfo == null || (_ipInfo$countryCode = ipInfo.countryCode) == null ? void 0 : _ipInfo$countryCode.call(ipInfo));
};
export const getIPData = ipInfo => {
  const description = getDescription(ipInfo);
  const threat = getThreat(ipInfo);
  const image = getFlagImage(ipInfo);

  // Extracting zip and country from ipInfo
  const zip = ipInfo.zipCode();
  const country = ipInfo.countryCode(); // Assuming the country code is used as 'country'

  return {
    description,
    threat,
    image,
    zip,
    country
  };
};
flarum.reg.add('fof-geoip', 'common/helpers/IPDataHelper', { getDescription: getDescription,getThreat: getThreat,getFlagImageForCountry: getFlagImageForCountry,getFlagImage: getFlagImage,getIPData: getIPData, });